const postActionsStore = {
  toastr: 'Ação adicionada',
  toastr1: 'A Ação foi adicionado com sucesso'
};

export default postActionsStore;
